import React from "react";
import styles from "./FormPolicy.module.scss";

const FormPolicy = () => {
  return (
    <div className={styles.formText}>
      By submitting this form, you confirm that you have read Apphud{" "}
      <a
        href="https://legal.apphud.com/privacy"
        target="_blank"
        className={styles.link}
      >
        Privacy Policy
      </a>{" "}
      and{" "}
      <a
        href="https://legal.apphud.com/terms"
        target="_blank"
        className={styles.link}
      >
        Terms and Conditions
      </a>
      . Also, you agree to receive marketing messages to your email
    </div>
  );
};

export default FormPolicy;
